import { useAuth } from "../../context/AuthContext";
import { useState } from "react";
import { Card, Avatar, Button, Input, Divider, Modal, Typography, message } from "antd";
import { EditOutlined, DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { api } from "../../services/api";
import { useMediaQuery } from "react-responsive";
import { MiCliente } from "./MiCliente";

const { Title, Text } = Typography;

export const Perfil = () => {
  const { user, clienteActual, clientes, tienda, selectCliente } = useAuth();
  const isMobile = useMediaQuery({ query: '(max-width: 900px)' });
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({
    nombre: user?.nombre || "",
    apellido: user?.apellido || "",
    telefono: user?.telefono || "",
  });
  const [bajaDialog, setBajaDialog] = useState(false);
  const [clienteMenuOpen, setClienteMenuOpen] = useState(false);

  if (!user) return null;

  const handleCancel = () => {
    setEdit(false);
    setForm({ nombre: user?.nombre || "", apellido: user?.apellido || "", telefono: user?.telefono || "" });
  };

  const handleSave = async () => {
    try {
      const res = await api.usuario.editUsuario(form);
      if (res.status === "success") {
        setEdit(false);
        message.success("Datos actualizados");
      } else {
        message.error(res.message || "Error al actualizar los datos");
      }
    } catch {
      message.error("Error al actualizar los datos");
    }
  };

  const handleBaja = async () => {
    try {
      const res = await api.usuario.bajaUser();
      if (res.status === "success") {
        window.location.href = "/";
      } else {
        message.error(res.message || "No se pudo dar de baja la cuenta");
        setBajaDialog(false);
      }
    } catch {
      message.error("No se pudo dar de baja la cuenta");
      setBajaDialog(false);
    }
  };

  const handleSelectCliente = async (id) => {
    try {
      await selectCliente(id);
      setClienteMenuOpen(false);
      window.location.reload();
    } catch {
      message.error("Error al cambiar de cliente");
    }
  };

  const getInitials = (u) => {
    if (u.nombre || u.apellido) return ((u.nombre?.[0] || "") + (u.apellido?.[0] || "")).toUpperCase();
    if (u.usuario) return u.usuario.charAt(0).toUpperCase();
    if (u.email) return u.email.charAt(0).toUpperCase();
    return "U";
  };

  const displayName = (user.nombre || user.apellido) ? `${user.nombre || ""} ${user.apellido || ""}`.trim() : user.usuario;

  return (
    <div style={{ maxWidth: 500, margin: '40px auto', minHeight: isMobile ? "60vh" : "70vh", padding: '0 16px' }}>
      <Card bordered={!isMobile} style={{ borderRadius: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Avatar size={50} style={{ backgroundColor: "var(--color-primary)", fontSize: 22, flexShrink: 0 }}>
            {getInitials(user)}
          </Avatar>
          <div>
            <Title level={5} style={{ margin: 0 }}>{displayName}</Title>
            <Text type="secondary">{user.usuario}</Text>
          </div>
        </div>

        <Divider />

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <Text strong>Datos personales</Text>
          {!edit && (
            <Button type="text" icon={<EditOutlined style={{ color: "var(--color-primary)" }} />} onClick={() => setEdit(true)} style={{ color: "var(--color-primary)" }}>
              Editar
            </Button>
          )}
        </div>

        {edit ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <Input placeholder="Nombre" value={form.nombre} onChange={(e) => setForm(p => ({ ...p, nombre: e.target.value }))} />
            <Input placeholder="Apellido" value={form.apellido} onChange={(e) => setForm(p => ({ ...p, apellido: e.target.value }))} />
            <Input placeholder="Teléfono" value={form.telefono} onChange={(e) => setForm(p => ({ ...p, telefono: e.target.value }))} />
            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <Button onClick={handleCancel}>Cancelar</Button>
              <Button type="primary" onClick={handleSave}>Guardar</Button>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, textAlign: "left" }}>
            <Text type="secondary">Nombre: <strong>{user.nombre || "-"}</strong></Text>
            <Text type="secondary">Apellido: <strong>{user.apellido || "-"}</strong></Text>
            <Text type="secondary">Teléfono: <strong>{user.telefono || "-"}</strong></Text>
          </div>
        )}

        <Divider />

        {user.id_rol === 1 ? (
          <div style={{ marginBottom: 24 }}>
            <Text strong style={{ display: "block", marginBottom: 12 }}>Tienda</Text>
            <div style={{ display: "flex", alignItems: "center", background: "#f7f7f9", borderRadius: 16, border: "1px solid #e0e0e0", padding: 16, gap: 16 }}>
              <Avatar size={35} style={{ backgroundColor: "var(--color-primary)", fontWeight: 600, fontSize: 12, flexShrink: 0 }}>
                {tienda?.display_name ? tienda.display_name.slice(0, 2).toUpperCase() : tienda?.nombre ? tienda.nombre.slice(0, 2).toUpperCase() : "T"}
              </Avatar>
              <div style={{ minWidth: 0 }}>
                <Text strong style={{ display: "block", lineHeight: 1.2 }}>{tienda?.display_name || tienda?.nombre || "-"}</Text>
                {tienda?.nombre && tienda?.display_name && tienda.display_name !== tienda.nombre && (
                  <Text type="secondary">{tienda.nombre}</Text>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ marginBottom: 24 }}>
            <MiCliente user={user} />

            {/* Quien compra para más de un cliente (ERP legacy) elige con cuál. */}
            {clientes.length > 1 && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 24 }}>
                <Text strong>Comprando como {clienteActual?.nombre || "—"}</Text>
                <Button
                  type="text"
                  icon={clienteMenuOpen ? <UpOutlined /> : <DownOutlined />}
                  onClick={() => setClienteMenuOpen(!clienteMenuOpen)}
                  style={{ color: "var(--color-primary)" }}
                >
                  Cambiar
                </Button>
              </div>
            )}

            {clienteMenuOpen && clientes.length > 1 && (
              <div style={{ marginTop: 8, border: "1px solid #e0e0e0", borderRadius: 12, overflow: "hidden" }}>
                {clientes.map((cliente) => (
                  <div
                    key={cliente.id}
                    onClick={() => handleSelectCliente(cliente.id)}
                    style={{
                      display: "flex", alignItems: "center", gap: 12, padding: "12px 16px",
                      cursor: "pointer", background: cliente.id === clienteActual?.id ? "#f0f7ff" : "#fff",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <Avatar size={28} style={{ backgroundColor: "var(--color-primary)", fontSize: 12 }}>
                      {cliente.nombre.slice(0, 2).toUpperCase()}
                    </Avatar>
                    <Text strong={cliente.id === clienteActual?.id} style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                      {cliente.nombre}
                    </Text>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        <Divider />

        <Button danger icon={<DeleteOutlined />} onClick={() => setBajaDialog(true)}>
          Dar de baja mi cuenta
        </Button>
      </Card>

      <Modal
        open={bajaDialog}
        onCancel={() => setBajaDialog(false)}
        title="¿Estás seguro?"
        footer={[
          <Button key="cancel" onClick={() => setBajaDialog(false)}>Cancelar</Button>,
          <Button key="confirm" danger type="primary" onClick={handleBaja}>Dar de baja</Button>,
        ]}
        width={400}
      >
        <Text>Esta acción dará de baja tu cuenta y no podrás acceder más. ¿Deseas continuar?</Text>
      </Modal>
    </div>
  );
};
